import React from "react";
import axios from 'axios';

import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";
import './../MoneyTransferComponent/Subtransaction.css';
import './../MoneyTransferComponent/MoneyTransfer.css';
import FooterComponet from "../FooterComponent/FooterComponet";
import $ from "jquery";
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';
import { Link } from "react-router-dom";
import ProgressGif from '../../assests/images/progress.gif';
import ProgressStatic from '../../assests/images/progress.jpg';
import MtFailed from '../../assests/images/mtfailed.png';
import MtSuccess from '../../assests/images/mtsuccess.png';
import MtPartial from '../../assests/images/mtpartial.png';
import HeaderCommon from '../HeaderComponent/HeadeCommon';
import Menu from "../MenuComponent/Menu";
import tokenErrorHandler from "../tokenErrorHandler";
import { setAepsCashWithDrwalReq, setAepsSection, setBiometricDtaCaptureStatus } from "../../redux/aeps/aeps.action";

const httpClient = axios.create();

class AepsCashWithdrawlDetails extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			moneyTransferFinalStatusCompleted: false,
			finalTransferMessage: '',
			counter: 0,
			exceptionCounter: 0,
			moneyTransferProgress1: '',
			orderRes: '',
			orderResDisplayMsg: '',
			orderResThirdPartyRespMsg: ''
		}
	}


	componentDidMount() {

		this.createOrder();
	}

	createOrder() {
		this.setState({
			progress: 'started',
			orderResDisplayMsg: '',
			orderResThirdPartyRespMsg: ''
		})

		
		
		// var request = {
		// 	"orderId": "12345123459",
		// 	"header": {
		// 		"msgType": "CREATE_ORDER",
		// 		"service": "AEPS",
		// 		"src": "aeps",
		// 		"dst": "aeps",
		// 		"channel": "WHITELABEL",
		// 		"requesterId": "W9853028034FPAY",
		// 		"requestId": "00a4070f-9608-47ea-99e3-ae22675e83fd",
		// 		"time": "2022-12-14T13:45:04.228Z"
		// 	},
		// 	"device": {
		// 		"type": "PC",
		// 		"id": null,
		// 		"os": "WINDOWS",
		// 		"osVer": " Win64",
		// 		"ip": "103.170.182.77",
		// 		"browser": "Mozilla Firefox",
		// 		"location": {
		// 			"type": "Point",
		// 			"coordinates": [
		// 				22.5664528,
		// 				88.3215014
		// 			]
		// 		}
		// 	},
		// 	"agentId": "123456789123",
		// 	"validated": true,
		// 	"transaction": {
		// 		"mobile": "8583806474",
		// 		"customerId": "409136448609",
		// 		"amount": 100,
		// 		"operator": "607152",
		// 		"category": "AEPS_CASHOUT"
		// 	},
		// 	"optional": {
		// 		"BIOMETRIC": "<PidData>\n  <Resp errCode=\"0\" errInfo=\"\" fCount=\"1\" fType=\"2\" iCount=\"0\" iType=\"\" pCount=\"0\" pType=\"\" nmPoints=\"30\" qScore=\"20\"/>\n  <DeviceInfo dpId=\"PRECISION.PB\" rdsId=\"PRECISION.WIN.001\" rdsVer=\"1.2.6\" dc=\"c4d6c81c-cfa7-4206-a6a1-92bbc65c8d67\" mi=\"PB510\" mc=\"MIID+jCCAuKgAwIBAgIIGx06pgSLOmAwDQYJKoZIhvcNAQELBQAwgewxNzA1BgNVBAMTLkRTIFBSRUNJU0lPTiBCSU9NRVRSSUMgSU5ESUEgUFJJVkFURSBMSU1JVEVEIDMxJjAkBgNVBDMTHU5PIDIyIEhBQklCVUxMQUggUk9BRCBUIE5BR0FSMRAwDgYDVQQJEwdDSEVOTkFJMRIwEAYDVQQIEwlUQU1JTE5BRFUxIjAgBgNVBAsTGVNPTFVUSU9OIERFVkVMT1BNRU5UIFRFQU0xMjAwBgNVBAoTKVBSRUNJU0lPTiBCSU9NRVRSSUMgSU5ESUEgUFJJVkFURSBMSU1JVEVEMQswCQYDVQQGEwJJTjAeFw0yMjEyMTMwODM5MjlaFw0yMzAxMTIwODM5MjlaMFAxFDASBgNVBAoMC1BSRUNJU0lPTlJEMRIwEAYDVQQDDAlQcmVjaXNpb24xEDAOBgNVBAcMB0NIRU5OQUkxEjAQBgNVBAsMCUJpb21ldHJpYzCCASIwDQYJKoZIhvcNAQEBBQADggEPADCCAQoCggEBANwkujP92hIYsRk3H66/IkpuOZxVmTBZXqW8OVeb/+e1XZ5ubVjWh4MZKXeNcNKuKhTUjrd1TZWlY4pSh14+2WDuCOZy3LBQNNhiYuUOfCXjiAQDhdnj0M0JKt2Pjqp+WFeOx9yHtuYrwWSRNWkY4QGXqR4ezlHoe0auNI0Y0YBdce7OtD4nkMHKB2Jjy9eC67f9ebGmm1Kni2/D6Jn1oHJT3wVrU5WC9h46tI5LjmfEfxy8UpvToI02HyyRrRjsmdkr/162HuPE11tactQvBI/dHLP5fmG57W6GO3xARhm9j5nXYUjAwXS7Ahb3OP+tg13URiaF+ZdSo9rqM0u/RHUCAwEAAaM7MDkwCQYDVR0TBAIwADALBgNVHQ8EBAMCAYYwHwYDVR0jBBgwFoAUtTWwpFcL+TBx63TcMhe9Ih9zKGcwDQYJKoZIhvcNAQELBQADggEBAI9SDfsNVU9p37L1JsEPuH2TDdhP/RG2kKup8JschkwkZ3n1aSQIika10J37DhY4HoJ+SbqKCLekYuIV97jjk/IBO/TxPiL4fFa2eRlQq56JL8zTC+1gXNfUdwY4705TxrH3huRqOoffK90mU9eyDI70Kpg9iVFCrsS4DUW6ceCCjSohEawTDFyirIpvNtz7j4D4UX/OrTvAAxoKXtSSdaOIWiY0BvrVl40jQdsj9s8/HMsekDZW8we5UmwOMMTtOf63ig3BEV2qERlyGB59TiNqkt5nSBUJWLokrLGjyc88IQJpvR59/V5565aLvbt5bptnO8Cer0z+xVCPRVV/uPA=\">\n    <additional_info>\n      <Param name=\"srno\" value=\"EBJU0416ZRBK71132110\"/>\n      <Param name=\"ts\" value=\"2022-12-14 19:15:02 +05:30\"/>\n      <Param name=\"sysid\" value=\"084CE15D-C4B2-11EA-80DE-002B67D5814B\"/>\n      <Param name=\"Locking\" value=\"N\"/>\n    </additional_info>\n  </DeviceInfo>\n  <Skey ci=\"20250923\">ifoC3gGhzlLL6igDszfCKLMLcGSJkq+YQX5YBDMsFuNd2WqcJi+5k7fr5fAYP6PfxUU8u3JP83Uq5rBUr2krz4+6tK/UOTNQHcdgeebfu51l/My0GBklTj+BBlMWZJ7lSd8xhy2FJHDDzmrQoG2RToD0iL2f/gheQuSGBhdnCGrnOaNqc65oZvPRHh2QAhPCijgBPNpmL2RTGscmIBYO5iXiwVUMVsKbKN5/fMsc1A2+vOjmgzTOuKvKD/dtHMwjzVX8iMud81n9qz89VZRrxUhOxO3ljjnQ5cONlXhez4x1q5eS1ymMDH9v98IGfvIpNJmmkeD6EyL9v/jIDhfOhg==</Skey>\n  <Hmac>GhqefPGWsBkxleoShr3L1Si+90lNMLqWUZX7znvI6tqD82HE5ufaMokXk1O/P52+</Hmac>\n  <Data type=\"X\">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</Data>\n</PidData>"
		// 	}
		// }
		var request = this.props.aepsCashWithDrawllReq;
		store.dispatch(setAepsCashWithDrwalReq(request));
		



		
		var url = '/api/v1/aeps/order/create';
		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}
		httpClient.post(url, request, { headers }
		).then((response) => {
			// response.data={
			// 	"header": {
			// 		"msgType": "AEPS_CASHOUT",
			// 		"service": "AEPS",
			// 		"src": "aeps",
			// 		"dst": "aeps",
			// 		"channel": "WHITELABEL",
			// 		"requesterId": "W767285296CMS",
			// 		"requestId": "f29262f8-3489-4234-9bbb-0ad304129740",
			// 		"time": "2023-02-10T11:30:15.034",
			// 		"traceId": "e93ef780-c6ec-4bf3-8be0-65dab9c09d81",
			// 		"hops": null
			// 	},
			// 	"response": {
			// 		"traceId": "e93ef780-c6ec-4bf3-8be0-65dab9c09d81",
			// 		"success": true,
			// 		"code": null,
			// 		"msg": "SUCCESS",
			// 		"displayMsg": "AEPS Transaction Success",
			// 		"tpsRspMsg": "AEPS Transaction Success",
			// 		"time": "2023-02-10T17:00:21.599814036",
			// 		"exception": null
			// 	},
			// 	"orderId": "030730dc-4f49-4b8d-9133-876cb15ae425",
			// 	"operatorId": "42618416",
			// 	"bankId": "304117000945",
			// 	"balance": "10000",
			// 	"statement": null,
			// 	"optional": {
			// 		"ackno": "42618416",
			// 		"amount": "10000",
			// 		"balanceamount": "3049.6",
			// 		"bankiin": "607400",
			// 		"bankrrn": "304117000945",
			// 		"clientrefno": "230210050000016",
			// 		"message": "AEPS Transaction Success"
			// 	}
			// }

			console.log('aeps action response' + JSON.stringify(response.data));

			if (response.data.response.success == true &&
				response.data.response.msg == 'SUCCESS') {
				store.dispatch(setBiometricDtaCaptureStatus(''));
				this.setState({
					progress: 'completed'
				})

				this.setState({
					orderRes: response.data
				})


			} else {

				store.dispatch(setBiometricDtaCaptureStatus(''));

				var msg = '';
				if (response.data.response.tpsRspMsg != null &&
					response.data.response.tpsRspMsg != undefined &&
					response.data.response.tpsRspMsg != '' &&
					response.data.response.tpsRspMsg.trim().includes("response_code")) {

					var arrayV = response.data.response.tpsRspMsg.trim().split(":");
					msg = (arrayV[arrayV.length - 1]);
					msg = msg.substring(1, msg.length - 4);

					// msg = response.data.response.tpsRspMsg.substring(response.data.response.tpsRspMsg.indexOf("message:"),
					//     response.data.response.tpsRspMsg.length);
				} else {
					msg = response.data.response.tpsRspMsg;
				}
				this.setState({
					progress: 'completed',
					orderRes: response.data,
					orderServiceErrMsg: 'Error-' + response.data.response.displayMsg,
					orderResDisplayMsg: response.data.response.displayMsg,
					orderResThirdPartyRespMsg: msg,
				})


			}
		}).catch(error => {
			this.setState({
				progress: 'completed',
				orderServiceErrMsg: error.message
			})
			store.dispatch(setBiometricDtaCaptureStatus(''));

			console.log(error.message);

			if (error.message.includes("401")) {
				tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			} else {

			}
		});
	}






	componentWillUnmount() {
	}


	print = (event) => {
		event.preventDefault();
		window.print();
	}

	backToAeps = (event) => {
		event.preventDefault();
		store.dispatch(setAepsSection('aepsForm'));
		var backaepsbtn1 = document.getElementById('backaepsbtn1');
		backaepsbtn1.click();

	}


	render() {
		return (

			<div>
				<HeaderCommon />
				<Menu />
				<div class="main">
					<div class="right-side">
						<div class="container-fluid">
							<div class="row">
								<div class="col-12">
									<div class="card-b" id="rightdiv">
										<div id="recenttxn">
											<div class="head">
												<h3>AePS CashWithdrawl Details</h3>
												<Link to='/aeps'>
													<button type="button" id="backaepsbtn1" hidden={true}></button>
												</Link>
												{/* <Link to='/aeps'> */}
												<button id="backaepsbtn" class="dbbtn" onClick={this.backToAeps}>Back</button>
												{/* </Link> */}
											</div>

											<div class="benedtls">
												<div class="row">
													<div class="col-12 col-lg-4 order-lg-2">

														{(
															this.state.progress == 'started') ?
															<div class="mtprogess" id="mtrun">
																<img src={ProgressGif} alt="process" class="img-fluid" />
																<h3 class="pending">Transaction in process...Please don't refresh</h3>
															</div>
															:
															this.state.progress == 'completed' &&
																this.state.orderRes != '' &&
																(
																	this.state.orderRes.response.success == true &&
																	this.state.orderRes.response.msg == 'SUCCESS') ?
																<div class="mtprogess" id="mtdone">
																	<img src={MtSuccess} alt="process" class="img-fluid" />
																	<h3 class='success'>Cash Withdrawl successful</h3>
																	<p class='success'>Available Balance : {(this.state.orderRes.optional != null &&
																		this.state.orderRes.optional != '' &&
																		this.state.orderRes.optional != undefined) ?
																		(this.state.orderRes.optional.balanceamount != null &&
																			this.state.orderRes.optional.balanceamount != '' &&
																			this.state.orderRes.optional.balanceamount != undefined) ?
																			this.state.orderRes.optional.balanceamount : 'NA' : 'NA'}</p>
																</div>
																:
																<div class="mtprogess" id="mtfailed">
																	<img src={MtFailed} alt="process" class="img-fluid" />
																	<h3 class="failed">Cash Withdrawl Failed</h3>
																</div>

														}

													</div>
													<div class="col-12 col-md-6 col-lg-4 order-lg-1">
														<div class="graycard">
															<div class="bankdtl">
																{/* <Avatar name={this.props.selectSender.customer.name} round={true} size="44" alt="" /> */}
																<h5>Name</h5>
																<p>{this.props.aepsFullName.toUpperCase()}</p>
															</div>
															<hr />
															<div class="bankdtl">
																<h5>Mobile Number</h5>
																<p>{this.props.aepsMobile}</p>
															</div>

														</div>
													</div>

													<div class="col-12 col-md-6 col-lg-4 order-lg-3">
														<div class="graycard">
															<div class="bankdtl">
																<h5>Retailer Id</h5>
																<p>{this.props.agentInfo.id}</p>
															</div>
															<hr />
															<div class="acntifsc">
																<h5>Retailer Name</h5>
																<p>{this.props.agentInfo.kioskName}</p>
															</div>

															<div class="acntifsc rtxt">
																<h5>Kiosk Code</h5>
																<p>{this.props.agentInfo.kioskCode}</p>
															</div>
														</div>
													</div>
												</div>
											</div>




											{this.state.progress == 'completed' &&
												this.state.orderRes != '' &&
												<div class="subtxn">
													<h4>Sub Transactions</h4>
													{(this.state.orderRes.response.success == true &&
														this.state.orderRes.response.msg == 'SUCCESS') ?
														<div class='subtxn-success'>
															<div class="col-6 col-md-3 col-lg-3 order-md-1">
																<div class="subtxt txnsts">
																	{/* {'Successful '} */}
																	<b>   RRN NO: {(this.state.orderRes.bankId != null) ? this.state.orderRes.bankId : 'NA'}</b></div>
															</div>
															{/* <div class="col-6 col-md-3 col-lg-3 order-md-1">
																<div class="subtxt txnsts">RRN NO: {(this.state.orderRes.bankId!=null && this.state.orderRes.bankId!='')?this.state.orderRes.bankId:''}</div>
															</div> */}

															<div class="row">
																<div class="col-6 col-md-2 col-lg-4 order-md-4">


																	<div class="subtxt subamunt rtxt"> ₹ {parseFloat(this.props.aepsCashWithDrawllReq.transaction.amount)}</div>

																</div>

																<div class="col-12 col-md-4 col-lg-6 order-md-2">
																	<div class="subtxt subid">Txn: {this.state.orderRes.orderId != null ?
																		this.state.orderRes.orderId : 'NA'}</div>
																</div>

																<div class="col-12 col-md-3 col-lg-4 order-md-3">
																	<div class="subtxt">{moment().format('DD-MM-YYYY HH:mm:ss')}</div>
																</div>

															</div>
														</div> :

														<div class='subtxn-failed'>
															<div class="col-6 col-md-3 col-lg-3 order-md-1">
																<div class="subtxt txnsts">
																	{/* {'Failed '} */}
																	<b>   RRN NO: {(this.state.orderRes.bankId != null) ? this.state.orderRes.bankId : 'NA'}</b>
																</div>

															</div>




															<div class="row">
																<div class="col-6 col-md-2 col-lg-6 order-md-4">
																	<div class="subtxt subamunt rtxt">₹ {parseFloat(this.props.aepsCashWithDrawllReq.transaction.amount)}</div>
																</div>

																<div class="col-12 col-md-4 col-lg-4 order-md-2">
																	<div class="subtxt subid"> Txn: {this.state.orderRes.orderId != null ?
																		this.state.orderRes.orderId : 'NA'}</div>
																</div>

																<div class="col-12 col-md-3 col-lg-3 order-md-3">
																	<div class="subtxt">{moment().format('DD-MM-YYYY HH:mm:ss')}</div>
																</div>
															</div>


															<div class="col-12">

																{this.state.orderResDisplayMsg != null &&
																	this.state.orderResDisplayMsg != undefined &&
																	this.state.orderResDisplayMsg != '' &&
																	<div class="subtxt txnsts">
																		<b> Message:{this.state.orderResDisplayMsg}
																		</b>
																	</div>
																}

																{this.state.orderResThirdPartyRespMsg != null &&
																	this.state.orderResThirdPartyRespMsg != undefined &&
																	this.state.orderResThirdPartyRespMsg != '' &&
																	<div class="subtxt txnsts">
																		<b> Third Party Message:{this.state.orderResThirdPartyRespMsg}
																		</b>
																	</div>
																}


															</div>
														</div>
													}
												</div>
											}




											{this.state.progress == 'completed' &&
												this.state.orderRes != '' &&
												<div class="paydtl">
													<div class="row">
														<div class="col-12 col-sm-6">
															<div class="orderdetail">
																<div class="txnhead">Order Details</div>
																<div class="odramt">
																	{/* <p>RRN No <span>{(this.state.orderRes != '' &&
																		this.state.orderRes.bankId != '') ?
																		this.state.orderRes.bankId : 'NA'}</span></p> */}
																	<p>Order Amount <span>₹
																		{parseFloat(this.props.aepsCashWithDrawllReq.transaction.amount).toFixed(2)}</span></p>
																	<p>Commission <span>₹ {parseFloat(this.props.surcharge3).toFixed(2)}</span></p>
																</div>

															</div>
														</div>
														<div class="col-12 col-sm-6">
															<div class="tnsfrdetail">
																<div class="txnhead">Transaction Details</div>
																<div class="odramt">
																	{/* <p>RRN No <span>{(this.state.orderRes != '' &&
																		this.state.orderRes.bankId != '') ?
																		this.state.orderRes.bankId : 'NA'}</span></p> */}
																	<p>Transfer Amount <span>₹ {(
																		this.state.orderRes.response.success == true &&
																		this.state.orderRes.response.msg == 'SUCCESS' &&
																		this.props.transferTotalAmount3 != '' &&
																		this.props.surcharge3 != '')
																		? parseFloat(this.props.aepsCashWithDrawllReq.transaction.amount).toFixed(2)
																		: parseFloat(0).toFixed(2)}</span></p>
																	<p>Commission <span>₹ {(
																		this.state.orderRes.response.success == true &&
																		this.state.orderRes.response.msg == 'SUCCESS' &&
																		this.props.transferTotalAmount3 != '' &&
																		this.props.surcharge != '') ?
																		parseFloat(this.props.surcharge3).toFixed(2) : parseFloat(0).toFixed(2)}</span></p>
																</div>

															</div>
														</div>
													</div>
												</div>
											}


											{/* <div class="txn-btn">
												<button type="button" class="print" onClick={this.print}>Print</button>
												<button type="button" class="help"></button>
											</div> */}


										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<FooterComponet />
			</div>

		);
	}
}


const mapStateToProps = (
	{
		errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: {
			phone,
			agentInfo, token, clientRole, callBackUrl
		}
		, aepsReduce: { aepsCashWithDrawllReq, aepsFullName, aepsMobile, surcharge3, transferTotalAmount3 },

	}

) => ({
	errorMessage, loginErrorMessage, phone,
	agentInfo, token, clientRole, callBackUrl,
	aepsCashWithDrawllReq, aepsFullName, aepsMobile, surcharge3, transferTotalAmount3
});

export default connect(mapStateToProps, null)(AepsCashWithdrawlDetails);


